import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function FilterSubmitButton({
  className = "",
  clearStep,
  setValue,
  selectedTab = null,
  filterData,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const handleClear = (e) => {
    e.preventDefault();
    if (clearStep === "property_type") {
      setValue("property_type", "");
      setValue("polular_property_type", "");
      setValue("more_property_type", "");
      updateUrlAndReload();
    } else if (clearStep === "my_properties") {
      setValue("labels_text", "");
      setValue("labels_text", "");
      setValue("labels_includes_arr", []);
      setValue("labels_excludes_arr", []);
      removeKeysFromUrl([
        "labels_includes_arr",
        "labels_excludes_arr",
        "labels_text",
      ]);
      updateUrlAndReload();
    }
  };
  const removeKeysFromUrl = (keys) => {
    const searchParams = new URLSearchParams(location.search);

    keys.forEach((key) => {
      searchParams.delete(key); // Remove key from query string
    });

    // Update the URL without those keys
    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
  };
  const updateUrlAndReload = () => {
    const frmData = filterData;
    const queryString = Object.entries(frmData)
      .filter(([key, value]) => {
        // Remove if value is null, undefined, false, empty string
        return !(
          value === null ||
          value === undefined ||
          value === false ||
          value === "" ||
          value === "null" ||
          value === "false" ||
          value === "undefined"
        );
      })
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    navigate(
      {
        pathname: location.pathname,
        search: `?${queryString}`,
      },
      { replace: true }
    );
  };
  return (
    <>
      <div className={`btn_blk text-right ${className}`}>
        <button
          className="site_btn blank yellow_blank"
          type="button"
          onClick={handleClear}
        >
          Clear
        </button>
        <button type="submit" className="site_btn">
          Apply
        </button>
      </div>
    </>
  );
}
